// Side menu for pages with several sections (Station Setup, Reports, Store, Accounting): grouped
// links on wide screens, a dropdown on phones. groups = [{ label, items: [{ value, label, badge? }] }]
export default function SectionNav({ groups, value, onChange, label = "Sections" }) {
  const visible = groups.map((g) => ({ ...g, items: g.items.filter(Boolean) })).filter((g) => g.items.length);
  return (
    <>
      <select className="h-10 w-full rounded-md border bg-white px-3 text-sm lg:hidden" value={value}
        onChange={(e) => onChange(e.target.value)} aria-label={label} data-testid="section-nav-select">
        {visible.map((g) => (
          <optgroup key={g.label} label={g.label}>
            {g.items.map((it) => <option key={it.value} value={it.value}>{it.label}{it.badge ? ` (${it.badge})` : ""}</option>)}
          </optgroup>
        ))}
      </select>
      <nav className="hidden lg:block" aria-label={label}>
        <div className="sticky top-24 space-y-4">
          {visible.map((g) => (
            <div key={g.label}>
              {g.label && <div className="px-3 text-[11px] font-semibold uppercase tracking-wider text-slate-400">{g.label}</div>}
              <div className="mt-1 grid">
                {g.items.map((it) => (
                  <button key={it.value} type="button" onClick={() => onChange(it.value)} data-testid={`section-nav-${it.value}`}
                    aria-current={value === it.value ? "page" : undefined}
                    className={`flex items-center justify-between gap-2 rounded-md px-3 py-1.5 text-left text-sm transition-colors ${
                      value === it.value ? "bg-brand font-medium text-white" : "text-slate-700 hover:bg-slate-100"}`}>
                    <span>{it.label}</span>
                    {it.badge ? <span className="rounded-full bg-amber-500 px-1.5 text-[10px] font-bold text-white">{it.badge}</span> : null}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </nav>
    </>
  );
}

// Page layout: the menu on the left, the chosen section on the right
export function SectionLayout({ nav, children }) {
  return (
    <div className="grid gap-6 lg:grid-cols-[13rem_minmax(0,1fr)]">
      {nav}
      <div className="min-w-0">{children}</div>
    </div>
  );
}
